var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(-24.5 -34.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M31.75,39.5v6.71l9,4.54V35Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    className: "active",
    "data-name": "Path 78",
    d: "M40.75,40.625a2.25,2.25,0,0,1,0,4.5",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    className: "active",
    "data-name": "Rectangle 104",
    width: 4.5,
    height: 6.75,
    transform: "translate(27.25 39.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 2.25,
    height: 2.25,
    transform: "translate(25 41.75)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M28.375,46.25h2.25L32.875,53h-2.25Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveys);
export default __webpack_public_path__ + "static/media/surveys.6d1523c19734822e1bfaaaac7ba82893.svg";
export { ForwardRef as ReactComponent };